import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import {
	ExclamationMarkTriangularSvgComponent,
	ShareSvgComponent,
	ThreeDotsHorizontalSvgComponent,
	ThreeDotsVerticalSvgComponent,
} from '@uc/shared/svg';
import { DropdownDirective } from '@uc/utilities';

@Component({
	selector: 'uc-review-three-dots',
	templateUrl: './review-three-dots.component.html',
	imports: [
		DropdownDirective,
		ThreeDotsHorizontalSvgComponent,
		ThreeDotsVerticalSvgComponent,
		ShareSvgComponent,
		ExclamationMarkTriangularSvgComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewThreeDotsComponent {
	showModalPanel = output<string>();

	onShowModalPanel(params: string) {
		this.showModalPanel.emit(params);
	}
}
